<app-header [main]="false"/>
<app-slider id="home" [slides]="tour?.slider || []" [withBackground]="false"/>


<!--<div class="card">
  <p-galleria
    [value]="images"
    [responsiveOptions]="responsiveOptions"
    [containerStyle]="{ 'max-width': '640px' }"
    [numVisible]="5">
    <ng-template #item let-item>
      <img [src]="item.itemImageSrc" style="width:100%" alt="img"/>
    </ng-template>
    <ng-template #thumbnail let-item>
      <img [src]="item.thumbnailImageSrc" alt="img"/>
    </ng-template>
  </p-galleria>
</div>-->


@if (tour) {
  <h1>{{ tour.title | translate }}</h1>
  <hr class="highlights-hr">

  <div class="shopping-cart-wrapper">
    <app-shopping-cart [tour]="tour" [className]="'black-style'"/>
  </div>

  <!-- Start About Area -->
  <section id="about" class="place">
    @for (item of tour.content!.description; let last = $last; let i = $index; track item; ) {
      <div
        class="tour-description-content"
        [class.expanded]="isDescriptionExpanded(i)"
        [innerHTML]="item.text | translate">
      </div>

      <div class="show-more-container">
        <button
          type="button"
          class="show-more-button"
          [attr.aria-expanded]="isDescriptionExpanded(i)"
          (click)="toggleDescription(i)">
          {{ (isDescriptionExpanded(i) ? 'Show less' : 'Show more') | translate }}
          <i class="ph ph-caret-down"></i>
        </button>
      </div>

      @if (!last) {
        <hr class="highlights-hr">
      }
    }
  </section>

  <section>
    <div class="desc-section">

      <div class="text">
        <!-- Highlights Start Here -->
        <hr class="highlights-hr">
        <div class="highlights-wrapper">
          <div class="highlights-title">{{ 'Highlights' | translate }}</div>
          <div class="highlights-list">
            <p><span>1)</span> {{ 'Comfortable vehicles' | translate }}</p>
            <p><span>2)</span> {{ 'Pick up and drop off' | translate }}</p>
            <p><span>3)</span> {{ 'Bottled water provided' | translate }}</p>
            <p><span>4)</span> {{ 'Free Wi-Fi' | translate }}</p>
            <p><span>5)</span> {{ 'Free cancellation' | translate }}</p>
            <p><span>6)</span> {{ 'Starting time' | translate }}</p>
          </div>
        </div>
        <!-- Highlights End Here -->

        <!-- Currency Start Here -->
        <div class="currency_table">
          <app-prices-table [price]="+tour.price" [groupPrice]="+tour.groupPrice"/>
        </div>
        <!-- Currency End Here -->

        <!-- Tour Id Start Here -->
        <div class="tour_id">
          <div>
            <p><strong>{{ "Tour id" | translate }} - {{ tour.id }}</strong></p>
          </div>
        </div>
        <!-- Tour Id End Here -->

      </div>
    </div>
  </section>
  <!-- End About Start -->

    <!-- Book Online -->
  <app-book-online-section [tourId]="tour.id"/>
  <!-- End Book Online -->

    <!-- Tours -->
  <app-tours [shuffle]="true" id="tours"/>
  <!-- End Tours -->

    <!-- Video Start -->
  @if (tour.video) {
    <app-video [videoURL]="tour.video.url" [imagePath]="tour.video.bgImage"/>
  }
  <!-- Video End -->
}



@if (tour?.map) {
  <!-- GOOGLE MAP -->
  <div class="google_map" id="map">
    <p>{{ "Tour on map" | translate }}</p>
    <iframe
      width="100%"
      height="700"
      frameborder="0"
      style="border:0"
      [src]="safeUrl"
      allowfullscreen>
    </iframe>
  </div>
  <!-- END GOOGLE MAP -->
}
